import { SlotDayItemForm, SlotItemForm, SlotPolicyForm } from '../types/slotPolicy.types';

export const DAY_LABELS = ['월', '화', '수', '목', '금', '토', '일'] as const;

// 배민 영업일 기준 06:00~05:59 순서
export const VALID_HOURS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 0, 1, 2, 3, 4, 5];

// SLOTINFO 공통코드(SLOT1~SLOT4) → DEFAULT_SLOTS 인덱스 매핑
// SLOT1→index 1(아침점심피크), SLOT2→index 2(오후논피크), SLOT3→index 3(저녁피크), SLOT4→index 4(심야논피크)
export const SLOTINFO_IDX: Record<string, number> = { SLOT1: 1, SLOT2: 2, SLOT3: 3, SLOT4: 4 };
export const VAL_KEYS = ['val1', 'val2', 'val3', 'val4', 'val5', 'val6', 'val7'] as const;

const DEFAULT_DAYS: SlotDayItemForm[] = [1, 2, 3, 4, 5, 6, 7].map(dow => ({
    dayOfWeek: dow,
    startTime: '',
    endTime: '',
    targetCnt: '',
}));

export const DEFAULT_SLOT_ITEM: SlotItemForm = {
    seqNo: null,
    slotName: '',
    days: DEFAULT_DAYS.map(d => ({ ...d })),
};

export const DEFAULT_FORM: SlotPolicyForm = {
    seqNo: null,
    policyName: '',
    applyStartDate: '',
    requiredSlotCnt: '',
    acceptanceRate: '',
    selectedStandardAreas: [],
    useYn: 'Y',
    slots: [{ ...DEFAULT_SLOT_ITEM, days: DEFAULT_DAYS.map(d => ({ ...d })) }],
    isDefault: false,
};

// 신규 정책 등록 시 기본 슬롯 설정 (평일=1~5, 주말=6~7)
export const DEFAULT_SLOTS: SlotItemForm[] = [
    {
        seqNo: null,
        slotName: '아침',
        days: [1, 2, 3, 4, 5, 6, 7].map(dow => ({ dayOfWeek: dow, startTime: '06:00', endTime: '08:59', targetCnt: '' })),
    },
    {
        seqNo: null,
        slotName: '아침점심피크',
        days: [1, 2, 3, 4, 5, 6, 7].map(dow => ({
            dayOfWeek: dow,
            startTime: '09:00',
            endTime: dow <= 5 ? '12:59' : '13:59',
            targetCnt: '',
        })),
    },
    {
        seqNo: null,
        slotName: '오후논피크',
        days: [1, 2, 3, 4, 5, 6, 7].map(dow => ({
            dayOfWeek: dow,
            startTime: dow <= 5 ? '13:00' : '14:00',
            endTime: '16:59',
            targetCnt: '',
        })),
    },
    {
        seqNo: null,
        slotName: '저녁피크',
        days: [1, 2, 3, 4, 5, 6, 7].map(dow => ({ dayOfWeek: dow, startTime: '17:00', endTime: '19:59', targetCnt: '' })),
    },
    {
        seqNo: null,
        slotName: '심야논피크',
        days: [1, 2, 3, 4, 5, 6, 7].map(dow => ({ dayOfWeek: dow, startTime: '20:00', endTime: '23:59', targetCnt: '' })),
    },
    {
        seqNo: null,
        slotName: '심야',
        days: [1, 2, 3, 4, 5, 6, 7].map(dow => ({ dayOfWeek: dow, startTime: '00:00', endTime: '05:59', targetCnt: '0' })),
    },
];
